import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import {  MinisterioGeralV2, StringNull } from "../../../../types";

interface GetMembrosProps {

}


type ResponseMembrosCheckin = {
  listAll: MinisterioGeralV2[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: MinisterioGeralV2[]
  pagina: number
}

const GetGrupoCelula = (): ResponseMembrosCheckin => {

  const [listMinisterioGrupo, setMinisterioGrupo] = useState<MinisterioGeralV2[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<MinisterioGeralV2[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<MinisterioGeralV2[]>('ministerio/geral/v2/listar', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<MinisterioGeralV2[]>('ministerio/geral/v2/listar')
      .then(
        (sucesso) => {
          setMinisterioGrupo(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listMinisterioGrupo,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams
  };
}

export default GetGrupoCelula;
